/**
 * We use English comments only in this project.
 */
import { pinStyle, pinAnimation } from '../../lib/map/constants';
import { useMapStore } from '../../lib/map/store';
import { useEffect } from 'react';

export const MapPin: React.FC = () => {
  // Get marker position from the store
  const markerPosition = useMapStore(state => state.markerPosition);
  
  // Add effect to log position changes
  useEffect(() => {
    console.log('[DEBUG] MapPin - Position updated:', markerPosition);
  }, [markerPosition]);

  return (
    <>
      {/* Center marker - precisely shows map center position */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '12px',
        height: '12px',
        backgroundColor: '#FF3B30',
        borderRadius: '50%',
        border: '2px solid white',
        transform: 'translate(-50%, -50%)',
        zIndex: 35,
        pointerEvents: 'none',
        boxShadow: '0 1px 3px rgba(0,0,0,0.4)'
      }} />
      
      {/* Center reference circle */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        border: '2px solid rgba(255,59,48,0.5)',
        transform: 'translate(-50%, -50%)',
        zIndex: 34,
        pointerEvents: 'none'
      }} />
      
      {/* Center shadow */}
      <div style={{
        position: 'absolute',
        top: 'calc(50% + 6px)',
        left: '50%',
        width: '8px',
        height: '3px',
        borderRadius: '50%',
        backgroundColor: 'rgba(0,0,0,0.3)',
        transform: 'translateX(-50%)',
        zIndex: 33,
        pointerEvents: 'none'
      }} />
      
      {/* Instructions overlay */}
      <div 
        className="absolute top-16 left-1/2 transform -translate-x-1/2 bg-white px-4 py-2 rounded-full shadow-md z-20 text-sm opacity-80"
        style={{ 
          maxWidth: '80%', 
          textAlign: 'center',
          pointerEvents: 'none',
        }}
      >
        Drag the map to position the pin at your location
      </div>
    </>
  );
}; 